const Style = {

  message: 'relative p-8 overflow-hidden w-full rounded-panel mb-4',
  title: 'text-xl font-semibold m-0 mb-3',
  blueBg: 'bg-msg-info-bg',
  blueText: 'text-msg-info-text',
  greenBg: 'bg-msg-success-bg',
  greenText: 'text-msg-success-text',
  orangeBg: 'bg-msg-warning-bg',
  orangeText: 'text-msg-warning-text',
  redBg: 'bg-msg-error-bg',
  redText: 'text-msg-error-text',
  icon: 'float-left mr-6',
  content: 'float-left mt-6 width-auto overflow-hidden md:float-none md:mt-0',
  close: 'absolute top-5 right-5 opacity-60 w-4 h-4 cursor-pointer z-1 bg-transparent ease-in-out duration-300 hover:opacity-90',
  btn: 'mt-3'

}

export default Style;